module.exports = __webpack_public_path__ + "static/bannerSoftware-69daf102f1a70095c33a80f6d54f4220.png";